/**
 * @generated SignedSource<<4ce245015522b195c8b0a32bd953b6ff>>
 * @relayHash 1cc363ec0a8878a3883c74210aec4e75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ui_versionDriverFieldQuery$variables = {
  projectAri: string;
  searchText?: string | null | undefined;
};
export type ui_versionDriverFieldQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly suggestedDriversForJiraVersion: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly accountId: string;
            readonly extendedProfile?: {
              readonly jobTitle: string | null | undefined;
            } | null | undefined;
            readonly name: string;
            readonly picture: AGG$URL;
          };
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
  };
};
export type ui_versionDriverFieldQuery = {
  response: ui_versionDriverFieldQuery$data;
  variables: ui_versionDriverFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchText"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "searchText",
    "variableName": "searchText"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "picture"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_versionDriverFieldQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  {
                    "args": (v2/*: any*/),
                    "concreteType": "JiraVersionDriverConnection",
                    "kind": "LinkedField",
                    "name": "suggestedDriversForJiraVersion",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraVersionDriverEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": (v3/*: any*/),
                                  "action": "THROW",
                                  "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.accountId"
                                },
                                {
                                  "kind": "RequiredField",
                                  "field": (v4/*: any*/),
                                  "action": "THROW",
                                  "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.name"
                                },
                                (v5/*: any*/),
                                (v6/*: any*/)
                              ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_versionDriverFieldQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraVersionDriverConnection",
                "kind": "LinkedField",
                "name": "suggestedDriversForJiraVersion",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionDriverEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc",
    "metadata": {},
    "name": "ui_versionDriverFieldQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "43d45f30b77d193c46e6ddd3e1cb725a";

export default node;
